import _objectSpread from "/data/jenkins/workspace/saas-prod_cp-fe-bms-web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moreApply from '@/views/layout/moreApply.vue'; // @ is an alias to /src

import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'app-main',
  components: {
    moreApply: moreApply
  },
  data: function data() {
    return {
      moreApplyFlag: false
    };
  },
  beforeCreate: function beforeCreate() {},
  mounted: function mounted() {
    this.addErrorLog('ewweewee');
  },
  destroyed: function destroyed() {},
  computed: _objectSpread({}, mapGetters('errorLog', {
    errorLogs: 'errorLogs'
  }), {
    key: function key() {
      return this.$route.path;
    }
  }),
  methods: _objectSpread({}, mapActions('errorLog', {
    addErrorLog: 'addErrorLog'
  }))
};